module.exports = __webpack_public_path__ + "static/8-7992b2248b0fe1f9137d4d3c2d5d098a.jpg";